import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MobileService } from '@klickdata/core/mobile/src/mobile.service';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent implements OnInit, AfterViewInit {
    @Input()
    public link: any[];

    @Input()
    public disabled: boolean;

    @ViewChild('rla')
    public rla: RouterLinkActive;

    constructor(protected mobile: MobileService, protected elementRef: ElementRef) {}

    ngOnInit() {}

    ngAfterViewInit() {
        this.elementRef.nativeElement.style.display = 'block';
    }

    public onClick(): void {
        this.mobile.showMenu(false);
    }

    public isActive(): boolean {
        return this.rla.isActive;
    }
}
